import React, { useEffect } from "react";
import { FaGraduationCap, FaUsers } from "react-icons/fa";
import { GiOpenBook, GiWorld } from "react-icons/gi";
import { useLocation, useNavigate } from 'react-router-dom';

import GaleriaFacebook from "./GaleriaFacebook"; // IMPORTADO

import clases from "../components/assets/images/About/clasesceva.jpeg";
import eventos from "../components/assets/images/About/eventosceva.jpeg";

export const Instructor = () => {

  const location = useLocation();
  const navigate = useNavigate();

  const redirectToGallery = () => {
    navigate('/GaleriaCE');
  };

  const redirectToGalleryCN = () => {
    navigate('/GaleriaCN');
  };

  useEffect(() => {

    if (location.hash) {

      const element = document.querySelector(location.hash);

      if (element) {

        const headerOffset = 100;

        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY;

        const offsetPosition =
          elementPosition - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });

      }

    }

  }, [location]);

  return (

    <>

      <section className='instructor mb-16' id="gallery">

        <div className='container'>

          <div className='heading py-12 text-center w-2/3 m-auto md:w-full'>

            <h1 className='text-3xl font-semibold text-black'>

              Visita Nuestra Galeria Online

            </h1>

            <span className='text-[14px] mt-2 block'>

              Cevatur es el compañero ideal para vivir las mejores aventuras...

            </span>

          </div>

          <div className='content grid grid-cols-2 gap-5 md:grid-cols-1'>

            <div className='images rounded-lg relative overflow-hidden h-72 w-ful before:bg-backbg before:h-72 before:w-full before:absolute before:top-0 before:left-0 before:content before:z-10'>

              <img src={eventos} alt='' className='rounded-t-lg object-cover w-full h-72' />

              <div className='categ flex flex-col gap-4 absolute top-5 z-30 m-3 p-8 items-center justify-center text-center'>

                <h2 className='text-3xl text-white font-semibold'>

                  EVENTOS CEVATUR

                </h2>

                <button

                  onClick={() => {

                    redirectToGallery();

                    window.scrollTo({ top: 0, behavior: 'smooth' });

                  }}

                  className='text-[15px] py-2 px-4 border border-gray-200 rounded-md text-white'>

                  Nuestros mejores eventos en unas cuantas fotos

                </button>

              </div>

            </div>

            <div className='images rounded-lg relative overflow-hidden h-72 w-ful before:bg-backbg before:h-72 before:w-full before:absolute before:top-0 before:left-0 before:content before:z-10'>

              <img src={clases} alt='' className='rounded-t-lg object-cover w-full h-72 relative' />

              <div className='categ flex flex-col gap-4 absolute top-5 z-30 m-3 p-8 items-center justify-center text-center'>

                <h2 className='text-3xl text-white font-semibold'>

                  NUESTRAS CLASES

                </h2>

                <button

                  onClick={() => {

                    redirectToGalleryCN();

                    window.scrollTo({ top: 0, behavior: 'smooth' });

                  }}

                  className='text-[15px] py-2 px-4 border border-gray-200 rounded-md text-white'>

                  Lo mejor de estudiar con Cevatur, a través de imágenes

                </button>

              </div>

            </div>

          </div>


          {/* GALERIA FACEBOOK INSERTADA AQUI */}

          <div className="py-16">

            <GaleriaFacebook />

          </div>


          <div className='content'>

            <div className='heading py-12 text-center w-2/3 m-auto md:w-full'>

              <h1 className='text-3xl font-semibold text-black'>

                ESTAMOS ORGULLOSOS

              </h1>

              <span className='text-[14px] mt-2 block'>

                No tienes que luchar solo, tienes nuestra asistencia y ayuda.

              </span>

            </div>

            <div className='content grid grid-cols-4 gap-5 md:grid-cols-2'>

              <InstructorCard

                color='text-red-500'

                icon={<FaUsers size={40} />}

                title='100'

                desc='Estudiantes Matriculados'

              />

              <InstructorCard

                color='text-orange-500'

                icon={<GiOpenBook size={40} />}

                title='4'

                desc='Especialidades'

              />

              <InstructorCard

                color='text-purple-500'

                icon={<FaGraduationCap size={40} />}

                title='+5000'

                desc='graduados'

              />

              <InstructorCard

                color='text-indigo-500'

                icon={<GiWorld size={40} />}

                title='9'

                desc='Sedes en todo el Peru'

              />

            </div>

          </div>

        </div>

      </section>

    </>

  );

};


export const InstructorCard = (props) => {

  return (

    <div className='box p-5 py-5 rounded-md'>

      <div className={props.color}>

        {props.icon}

      </div>

      <div className='text mt-2'>

        <h4 className='text-lg font-semibold text-black'>

          {props.title}

        </h4>

        <p className='text-[15px]'>

          {props.desc}

        </p>

      </div>

    </div>

  );

};
